<section class="section py-6" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </section>
  <section class="section py-6" *ngIf="!isLoading">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Proceso {{ job.code }}</h2>
      </div>
    </div>
  </section>
  <section class="section py-1" *ngIf="!isLoading">
    <div class="columns has-background-white">
      <div class="column p-5">
        <form [formGroup]="form" (ngSubmit)="onSave()">
          <div class="columns">
            <div class="column is-3">
              <div class="field">
                <label class="label">Nombre</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Nombre" formControlName="name">
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Descripción</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Descripción" formControlName="description">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Activo</label>
                <input id="isActiveSwitch" type="checkbox" name="isActiveSwitch" class="switch is-rounded"
                  formControlName="is_active">
                <label for="isActiveSwitch"></label>
              </div>
            </div>
            <div class="column is-flex is-align-items-center">
              <button type="submit" class="button is-primary" [disabled]="!form.valid || !form.dirty">
                <span *ngIf="!isUpdateLoading">Guardar</span>
                <fa-icon [icon]="faSpinner" *ngIf="isUpdateLoading" [animation]="'spin'"></fa-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
  <section class="section py-6" *ngIf="!isLoading">
    <div class="columns">
      <div class="column header-title-page">
        <h4 class="title-header is-size-4">Ejecuciones</h4>
        <button class="button is-primary" (click)="runJob()">Lanzar proceso</button>
      </div>
    </div>
  </section>
  <section class="section py-1" *ngIf="!isLoading">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            <div class="table-job-executions" *ngIf="jobExecutions">
              <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="jobExecutions"></app-generic-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>